import { Component, Input, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { associateDocList } from '@app/_models/associateDocList';
import { AssociateService } from '@app/_services/associate.service';
import { DocumentVerificationListService } from '@app/_services/document-verification-list.service';
import { VerifyDocumentService } from '@app/_services/verifyDocument.service';
import { environment } from '@environments/environment';
import { first } from 'rxjs/operators';
import { LogService } from '@app/_shared/log.service';
import { Router } from '@angular/router';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';
import * as _moment from 'moment';
import { Moment } from 'moment';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';

const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'MMMM/YYYY',
  },
  display: {
    dateInput: 'MMMM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
@Component({
  selector: 'app-edit-doc-upload-list',
  templateUrl: './edit-doc-upload-list.component.html',
  styleUrls: ['./edit-doc-upload-list.component.css'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class EditDocUploadListComponent implements OnInit {
  date = new FormControl(moment());

  chosenYearHandler(normalizedYear: Moment) {
    const ctrlValue = this.date.value;
    ctrlValue.year(normalizedYear.year());
    this.date.setValue(ctrlValue);
  }

  chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
    const ctrlValue = this.date.value;
    ctrlValue.month(normalizedMonth.month());
    this.date.setValue(ctrlValue);
    datepicker.close();

    this.changeMonth=true
    let ea = this.editassociateDocList.controls.passingYearId
    let b = ea.setValue(this.date.value)
  }

  dateFilter = (d: any): boolean => {
    const day = d.year();
    var val = [];
    this.YearOfPassDropDown.forEach((keys: any, vals: any) => {
      var x = keys.yearOfPassing;
      var y: number = +x;
      day !== y + "";
      val.push(y);
    })
    var alphaNumeric = val.join("  && day !== ");;
    var aq = (day !== + alphaNumeric);
    var stringValueYouWant = val.join();

    return stringValueYouWant.indexOf(d.year()) !== -1;
    //return aq;
  }
  getTomorrow() {
    let d = new Date();
    d.setDate(d.getDate() + 1);

    return d;
  }

  src1;
  fileURL1;
  isUPdf: boolean = false;
  isUImage: boolean = false;
  returnUrl;
  editId;
  data;
  streamDropDown = [];
  collegeDropDown = [];
  YearOfPassDropDown = [];
  streamId: number;
  semId: number;
  branchId: number;
  streamName: string;
  semester: string;
  branchNm: string;
  collegeId: number;
  collegeName: string;
  yearOfPassId: number;
  yearOfPass: string;
  enrollNo: string;
  firstName: string;
  lastName: string;
  docPath;
  upload_doc_path: any;
  originalDocUploadFilePath: any;
  associateDocList: associateDocList[];
  editassociateDocList: FormGroup;
  filePath; response
  response1
  branchDropDown = [];
  semesterDropDown = [];
  SearchMonth: string;
  serachYear
  changeMonth: boolean = false;
  
  constructor(private associateService: AssociateService, private verifyDocService: VerifyDocumentService,
    private documentVerificationListService: DocumentVerificationListService, private formBuilder: FormBuilder, private eventService: LogService,
    private router: Router, private modalService: NgbModal) { }

  @ViewChild('showModalBox', { read: TemplateRef }) showModalBoxTemplate: TemplateRef<any>;

  @Input() childMessage: associateDocList[];

  ngOnInit(): void {

    this.response1 = this.childMessage;
    this.editId = this.response1.id;
    this.editassociateDocList = this.formBuilder.group({
      id: this.editId,
      // firstName: [''],
      // lastName: [''],
      streamId: [''],
      // collegeId: [''],
      enrollmentNo: [''],
      passingYearId: [''],
      filePath: [''],
      originalDocUploadFilePath: [''],
      semId: [''],
      // branchId: [''],
      userId: [''],
      yearAndMonth: [''],
      yearAndMonthSelect: [''],
      monthOfPassing: [''],
    });

    // this.editId =1;
    this.associateService.getDocById(this.editId)
      .pipe(first())
      .subscribe(
        data => {
          this.data = data.respData;
          this.streamId = data.respData.streamId;
          this.streamName = data.respData.streamName;
          this.collegeId = data.respData.collegeId;
          this.collegeName = data.respData.collegeName;
          this.yearOfPassId = data.respData.passingYearId;
          this.yearOfPass = data.respData.yearOfPass;
          this.enrollNo = data.respData.enrollmentNo;
          this.docPath = data.respData.originalDOCuploadfilePath;
          this.firstName = data.respData.firstName;
          this.lastName = data.respData.lastName;
          this.branchId = data.respData.branchId;
          this.semId = data.respData.semesterId;
          this.semester = data.respData.semester;
          this.branchNm = data.respData.branchNm;

          moment("01-01-2000 23:45", "DD-MM-YYYY HH:MM")

          this.editassociateDocList.value.monthOfPassing = moment(this.date.value.month() + 1, 'MM').format('MMMM')
          // this.date.value.year()."2022"MMMM/YYYY  monthOfPassing  passingYear
          let ea = this.editassociateDocList.controls.passingYearId
          let b = ea.setValue(moment(data.respData.passingYear + "/" + data.respData.monthOfPassing))
          this.SearchMonth = data.respData.monthOfPassing;
          this.serachYear = data.respData.passingYear
          this.verifyDocService.getBranch(this.streamId)
            .pipe(first())
            .subscribe(
              data => {
                // console.log("college response---", data.respData)
                this.branchDropDown = data.respData;
              },
              error => {
                console.log(error)
              }
            )

          this.verifyDocService.getSemester(this.streamId)
            .pipe(first())
            .subscribe(
              data => {
                // console.log("college response---", data.respData)
                this.semesterDropDown = data.respData;
              },
              error => {
                console.log(error)
              }
            )

          console.log(this.data)
        },
        error => {
          console.log(error)
        }
      )

    this.associateService.getVerifyDocument(this.editId)
      .pipe(first())
      .subscribe(
        data => {
          console.log("response---", data)
          this.documentVerificationListService.getverifydocumentImage(`${environment.apiUrl}` + data.respData.originalDocUploadFilePath).pipe(first())
            .subscribe(
              data2 => {
                console.log("data2---", data2, data2.type)
                  let reader = new FileReader();
                  if(data2.type == "application/pdf"){
                    this.isUPdf = true;
                    this.isUImage = false;
                    reader.addEventListener("load", () => {
                      this.originalDocUploadFilePath = reader.result;
                      var base64Array = this.originalDocUploadFilePath.substring(28);  
                      console.log("=====base64Array===========",base64Array);
                      this.src1 = this._base64ToArrayBuffer(base64Array);                    
                      let file = new Blob([data2], { type: 'application/pdf' });            
                      this.fileURL1 = URL.createObjectURL(file);
                      // window.open(this.fileURL);                    
                    }, false);
                    // this.src = this._base64ToArrayBuffer();
                  }else{
                    this.isUImage = true;
                    this.isUPdf = false;
                    reader.addEventListener("load", () => {
                      this.originalDocUploadFilePath = reader.result;
                      // var base64Array = this.upload_doc_path.substring(28);
                      // this.src = this._base64ToArrayBuffer(base64Array); 
                      // console.log("------------",this.src);
                      // console.log(base64Array);
                      console.log(reader.result);
                    }, false); 
                  }
                  console.log(this.isUImage, this.isUPdf)

                if (data2) {
                  reader.readAsDataURL(data2);
                }
                if(this.isUPdf == true){
            
                  var al = window.open('', 'OPEN'); 
                  window.setTimeout(function() {al.close()}, 100);
                  }
                // this.upload_doc_path = data2;
              }),

            // console.log(this.request)
            //this.dtTrigger.next();

            error => {
              this.upload_doc_path = "webapps/University/assets/images/EduCred_Logo.jpg";
              this.originalDocUploadFilePath = "webapps/University/assets/images/EduCred_Logo.jpg";
              // this.upload_doc_path = "assets/images/No-results-found.jpg";
              // this.originalDocUploadFilePath = "assets/images/No-results-found.jpg";
              console.log(error)
            }
        })

    this.verifyDocService.getStreams()
      .pipe(first())
      .subscribe(
        data => {
          // console.log("streams response---", data.respData)
          this.streamDropDown = data.respData;
        },
        error => {
          console.log(error)
        }
      )

    this.verifyDocService.getColleges()
      .pipe(first())
      .subscribe(
        data => {
          console.log("college response---", data.respData)
          this.collegeDropDown = data.respData;
        },
        error => {
          console.log(error)
        }
      )

    this.verifyDocService.getYearOfPassing()
      .pipe(first())
      .subscribe(
        data => {
          console.log("YearOfPassing response---", data.respData)
          this.YearOfPassDropDown = data.respData;
        },
        error => {
          console.log(error)
        }
      )
  }

  _base64ToArrayBuffer(base64) {
    var binary_string = base64.replace(/\\n/g, '');
    binary_string = window.atob(base64);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  }

  openPdf1(){
    window.open(this.fileURL1);
  }

  catchEvent(files: FileList) {
    console.log(files)

    var formData = new FormData();
    formData.append("file", files.item(0));
    this.associateService.uploadDocument(formData)
      .pipe(first())
      .subscribe(
        data => {
          console.log("file---upload---response---", data)
          this.filePath = data.respData;

          this.editassociateDocList.patchValue({
            // id: this.editId,
            filePath: this.filePath
          })
          console.log("----", this.editassociateDocList.value)
          // this.updateData(data.respData);
        },
        error => {
          console.log(error)
        }
      )

  }

  onSubmit() {

    // var r = this.YearOfPassDropDown.find(x => x.yearOfPassing === this.date.value.year().toString());
    // this.editassociateDocList.value.passingYearId = r.id,
      this.editassociateDocList.value.monthOfPassing = moment(this.date.value.month() + 1, 'MM').format('MMMM')
    if (this.changeMonth) {
      var r = this.YearOfPassDropDown.find(x => x.yearOfPassing === this.editassociateDocList.value.passingYearId.year().toString());
      this.editassociateDocList.value.passingYearId = r.id,
      
      this.editassociateDocList.value.monthOfPassing = this.editassociateDocList.value.monthOfPassing
    }
    else
    {
      var r = this.YearOfPassDropDown.find(x => x.yearOfPassing === this.serachYear.toString());
     this.editassociateDocList.value.passingYearId = r.id;
      this.editassociateDocList.value.monthOfPassing =  this.SearchMonth

    }
    console.log(this.editassociateDocList.value)
    let asssociateId = localStorage.getItem('user_id');
    this.editassociateDocList.value.userId = asssociateId;
    this.associateService.editDocument(this.editassociateDocList.value)
      .pipe(first())
      .subscribe(
        data => {
          console.log(data)
          if (data.respData == true) {

            this.modalService.open(this.showModalBoxTemplate);
            // alert('Record has been editted.')
          } else {
            alert('Record could not be editted')
          }
        }
      )

  }
  getBranAndStream(i: any) {
    let y = i.split(':')[1];
    let id = Number(y);
    //alert(  Number(this.getStreamId));

    this.verifyDocService.getBranch(id)
      .pipe(first())
      .subscribe(
        data => {
          // console.log("college response---", data.respData)
          this.branchDropDown = data.respData;
        },
        error => {
          console.log(error)
        }
      )


    this.verifyDocService.getSemester(id)
      .pipe(first())
      .subscribe(
        data => {
          // console.log("college response---", data.respData)
          this.semesterDropDown = data.respData;
        },
        error => {
          console.log(error)
        }
      )
  }

  callRoute(dataValue) {
    this.eventService.emit<string>(dataValue);
  }

  refresh(): void {
    // location.reload();
    this.modalService.dismissAll(this.showModalBoxTemplate);
    this.eventService.emit<string>('31');
    // this.returnUrl = "superAssociate";
    // this.router.navigate([this.returnUrl]);
  }
}
